import { startOfWeek, startOfMonth, endOfWeek, endOfMonth, isBefore, addDays, isSameDay, isWithinInterval, toDate, isValid, } from "date-fns";
export var identity = function (x) { return x; };
export var chunks = function (array, size) {
    return Array.from({ length: Math.ceil(array.length / size) }, function (_, i) {
        return array.slice(i * size, i * size + size);
    });
};
export var combine = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.filter(identity).join(" ");
};
// Date
export var getDaysInMonth = function (date) {
    var startWeek = startOfWeek(startOfMonth(date));
    var endWeek = endOfWeek(endOfMonth(date));
    var days = [];
    for (var curr = startWeek; isBefore(curr, endWeek);) {
        days.push(curr);
        curr = addDays(curr, 1);
    }
    return days;
};
export var isStartOfRange = function (_a, day) {
    var startDate = _a.startDate;
    return (startDate && isSameDay(day, startDate));
};
export var isEndOfRange = function (_a, day) {
    var endDate = _a.endDate;
    return (endDate && isSameDay(day, endDate));
};
export var inDateRange = function (_a, day) {
    var startDate = _a.startDate, endDate = _a.endDate;
    return (startDate &&
        endDate &&
        (isWithinInterval(day, { start: startDate, end: endDate }) ||
            isSameDay(day, startDate) ||
            isSameDay(day, endDate)));
};
export var isRangeSameDay = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    if (startDate && endDate) {
        return isSameDay(startDate, endDate);
    }
    return false;
};
export var parseOptionalDate = function (date, defaultValue) {
    if (date) {
        var parsed = toDate(date);
        if (isValid(parsed))
            return parsed;
    }
    return defaultValue;
};
//# sourceMappingURL=utils.js.map